// deno-fmt-ignore-file
import { FromType } from './from_type.mjs';
import { EvaluateIntersect } from '../evaluate/evaluate.mjs';
export function FromIntersect(types) {
    const evaluated = EvaluateIntersect(types);
    const result = FromType(evaluated);
    return result;
}
